export default __webpack_public_path__ + "static/media/iconVentasCli.540a0a31.png";